// extracted by mini-css-extract-plugin
export default {"name_page":"SocialShare_name_page__+4NZ-","bio":"SocialShare_bio__JPMcY","item_social":"SocialShare_item_social__ppvwG"};